import { render, staticRenderFns } from "./viewxqlsForm.vue?vue&type=template&id=633d11a6&"
import script from "./viewxqlsForm.vue?vue&type=script&lang=js&"
export * from "./viewxqlsForm.vue?vue&type=script&lang=js&"
import style0 from "./viewxqlsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "viewxqlsForm.vue"
export default component.exports